import React from 'react';
import { Link } from 'react-router-dom';
export function Compliance() {
  const infoPages = [{
    name: 'FAQs',
    path: '/12.html'
  }, {
    name: 'Compliance',
    path: '/Compliance'
  }, {
    name: 'Screen Printing Advice',
    path: '/Screen-Printing-Advice'
  }, {
    name: 'What is Vector Art?',
    path: '/What-is-Vector-Art'
  }, {
    name: 'The Wear Haus Way',
    path: '/The-Wear-Haus-Way'
  }, {
    name: 'Terms and Conditions',
    path: '/Terms'
  }, {
    name: 'Privacy Policy',
    path: '/Privacy'
  }];
  return <div className="flex flex-col w-full" data-id="element-509">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-wh-pink to-pink-600 py-16" data-id="element-510">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-511">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-512">
            Compliance
          </h1>
          <p className="text-xl text-white/90" data-id="element-513">
            Professional Packaging Services
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16 bg-gray-50" data-id="element-514">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-515">
          <div className="flex flex-col lg:flex-row gap-8" data-id="element-516">
            {/* Sidebar Navigation */}
            <aside className="lg:w-64 flex-shrink-0" data-id="element-517">
              <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 sticky top-24" data-id="element-518">
                <h3 className="text-lg font-bold text-gray-900 mb-4" data-id="element-519">
                  Helpful Info
                </h3>
                <nav className="space-y-2" data-id="element-520">
                  {infoPages.map(page => <Link key={page.path} to={page.path} className={`block px-3 py-2 rounded-md text-sm font-medium transition-colors ${page.path === '/Compliance' ? 'bg-wh-pink text-white' : 'text-gray-700 hover:bg-gray-100'}`} data-id="element-521">
                      {page.name}
                    </Link>)}
                </nav>
              </div>
            </aside>

            {/* Main Content Area */}
            <main className="flex-1" data-id="element-522">
              <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8" data-id="element-523">
                <div className="prose prose-lg max-w-none" data-id="element-524">
                  <p className="text-gray-700 mb-6" data-id="element-525">
                    Compliance packaging is important. If you don't believe us,
                    take notice the next time you're in the grocery store. Do
                    your eyes tend to be drawn toward the more plain packaged
                    items, or are you drawn to the high-quality, well-designed
                    packaging? Wear Haus offers services such as folding,
                    bagging, and tagging of your garments for this very reason.
                    Maybe you're a re-seller who relies on each item being
                    individually packaged, but you don't have the staff to
                    accomplish this task on your own. Let us handle the
                    packaging details for you! Compliance is our specialty.
                  </p>

                  <p className="text-gray-700" data-id="element-526">
                    <Link to="/Contact" className="text-wh-pink hover:text-pink-700 font-medium" data-id="element-527">
                      Contact us
                    </Link>{' '}
                    for details on pricing for these services.
                  </p>
                </div>
              </div>
            </main>
          </div>
        </div>
      </section>
    </div>;
}